import React from 'react';
import { TextInput } from 'ui/TextInput';
import { DecimalInput } from 'ui/stateful/DecimalInput';
import { getCurrencySymbol } from 'utils/currency';
import { formatPriceCents } from 'utils';
import { IDepositAccountAllocationState } from '../types';
import { dollarsToCents, centsToDollars } from '../utils';

interface IAllocateToDepositAccountSectionProps {
  allocation: IDepositAccountAllocationState;
  onUpdateDescription: (description: string) => void;
  onUpdateAmount: (amountCents: number) => void;
  isEnabled: boolean;
  isReadOnly?: boolean;
  exchangeCurrency: string;
}

export const AllocateToDepositAccountSection: React.FC<IAllocateToDepositAccountSectionProps> = ({
  allocation,
  onUpdateDescription,
  onUpdateAmount,
  isEnabled,
  isReadOnly = false,
  exchangeCurrency,
}) => {
  const currencySymbol = getCurrencySymbol(exchangeCurrency as any);

  const handleAmountBlur = (value: number | null) => {
    onUpdateAmount(dollarsToCents(value));
  };

  return (
    <div className="font-pt-sans">
      <span className="block uppercase text-13px tracking-2xs text-black mb-10px">Allocate to Deposit Account</span>

      {/* Form Fields Row */}
      <div className="flex gap-20px items-end">
        {/* Description */}
        <div className="flex-1">
          <label className="text-black font-pt-sans text-13px leading-17px tracking-2xs">Description</label>
          {isReadOnly ? (
            <div className="h-35px flex items-center bg-gray-10 px-10px">
              <span className="text-15px text-gray-100">{allocation.description || ''}</span>
            </div>
          ) : (
            <TextInput
              id="deposit-account-description"
              value={allocation.description}
              onChange={e => onUpdateDescription(e.currentTarget.value)}
              placeholder=""
              disabled={!isEnabled}
            />
          )}
        </div>

        {/* To Allocate / Allocated */}
        <div className="w-[147px]">
          <label className="text-black font-pt-sans text-13px leading-17px tracking-2xs text-right block">
            {isReadOnly ? 'Allocated' : 'To Allocate'}
          </label>
          {isReadOnly ? (
            <div className="h-35px flex items-center justify-between bg-gray-10 px-10px">
              <span className="text-15px text-gray-80">{currencySymbol}</span>
              <span className="text-15px text-gray-100">{formatPriceCents(allocation.amountCents)}</span>
            </div>
          ) : (
            <DecimalInput
              value={centsToDollars(allocation.amountCents)}
              onBlur={handleAmountBlur}
              decimalPlaces={2}
              disabled={!isEnabled}
              className="min-w-0 flex-1 text-right outline-none pr-10px bg-transparent"
              prefix={currencySymbol}
              prefixClassName="text-gray-80 text-15px pl-10px"
              wrapperClassName="border border-gray-40 h-35px w-full bg-white-hard"
            />
          )}
        </div>
      </div>
    </div>
  );
};
